import { render, staticRenderFns } from "./resumetwo.vue?vue&type=template&id=5b6fa6db&"
import script from "./resumetwo.vue?vue&type=script&lang=js&"
export * from "./resumetwo.vue?vue&type=script&lang=js&"
import style0 from "./resumetwo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports